module.exports = __webpack_public_path__ + "static/media/dong-contact-us.dece8ef2.svg";